import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ProductIdContainer, IDButton } from "./ProductId.styled";
import ProductView from "../../../ProductView/ProductView";
import AddEditProduct from "../../../AddEditProduct/AddEditProduct";
import {
  DivBackgroundLowOpacity,
  DivBackgroundFullOpacity,
} from "../../ProductsList.styled";

const ProductId = (props) => {
  const { t, newData, data, id, status, updateRefeshStatus, type, countries } =
    props;

  const [isProductViewPopupVisible, setProductViewPopupVisible] =
    useState(false);
  const [isEditProductPopupVisible, setIsEditProductPopupVisible] =
    useState(false);

  const onProductIdClick = () => {
    setProductViewPopupVisible(true);
  };
  const closeProductViewPopup = () => {
    setProductViewPopupVisible(false);
  };
  const onEdit = () => {
    setProductViewPopupVisible(false);
    setIsEditProductPopupVisible(true);
  };
  const closeProductEditPopup = () => {
    setIsEditProductPopupVisible(false);
  };

  return (
    <>
      {status && (
        <DivBackgroundFullOpacity>
          <ProductIdContainer>
            <IDButton onClick={onProductIdClick}>{data}</IDButton>
          </ProductIdContainer>
        </DivBackgroundFullOpacity>
      )}
      {!status && (
        <DivBackgroundLowOpacity>
          <ProductIdContainer>
            <IDButton onClick={onProductIdClick}>{data}</IDButton>
          </ProductIdContainer>
        </DivBackgroundLowOpacity>
      )}
      {isProductViewPopupVisible && (
        <ProductView
          id={id}
          productInfo={newData}
          title={t("PRODUCT") + " #" + id}
          onClose={closeProductViewPopup}
          onEdit={onEdit}
        />
      )}
      {isEditProductPopupVisible && (
        <AddEditProduct
          id={id}
          title={t("PRODUCT")}
          onClose={closeProductEditPopup}
          isEditMode
          updateRefeshStatus={updateRefeshStatus}
          countries={countries}
        />
      )}
    </>
  );
};

ProductId.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ProductId);
